import { render, staticRenderFns } from "./GamesList.vue?vue&type=template&id=40079c2d&scoped=true"
import script from "./GamesList.vue?vue&type=script&lang=js"
export * from "./GamesList.vue?vue&type=script&lang=js"
import style0 from "./GamesList.vue?vue&type=style&index=0&id=40079c2d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40079c2d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40079c2d')) {
      api.createRecord('40079c2d', component.options)
    } else {
      api.reload('40079c2d', component.options)
    }
    module.hot.accept("./GamesList.vue?vue&type=template&id=40079c2d&scoped=true", function () {
      api.rerender('40079c2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/dashboard/challenge-friends/components/GamesList.vue"
export default component.exports